import React, { useState } from "react";
import "./ValuationApproach.css";

const ValuationApproach = () => {
  const cards = [
    {
      icon: <img
        src="/assets/images/ValuationApproach/Vector.png"
        alt="↗"
      />,
      title: "Custom Valuation Models",
      subtitle: "Beyond standard DCF (Discounted Cash Flow), we use industry-specific methodologies for accuracy.",
      button: "Know More",
    },
    {
      icon: <img
        src="/assets/images/ValuationApproach/Vector.png"
        alt="↗"
      />,
      title: "Trusted Data Sources",
      subtitle: "Leverage verified financial databases and market benchmarks for reliable insights.",
      button: "Know More",
    },
    {
      icon: <img
        src="/assets/images/ValuationApproach/Vector.png"
        alt="↗"
      />,
      title:
        "Competitive Benchmarking",
      subtitle: "See how your business stacks up against competitors in your sector.",
      button: "Know More",
    },
    {
      icon: <img
        src="/assets/images/ValuationApproach/Vector.png"
        alt="↗"
      />,
      title: "Investor-Ready Reports",
      subtitle: "Detailed PDF reports tailored for fundraising, acquisitions, or exit strategies.",
      button: "Know More",
    },
  ];

  const [hoverIndex, setHoverIndex] = useState(null);
  return (
    <section className="valuation-section text-align-center-valuationSection">
      <div className="valuation-content">
        <h3 className="valuation-subtitle">Our Valuation Approach</h3>
        <h2 className="valuation-title-2">Valuing More Than Numbers</h2>
        <h1 className="valuation-title">Data-Driven & Humanized Methodology</h1>
        <p className="valuation-description">
        We make valuations accessible, accurate, and actionable for businesses globally
        </p>
      </div>
      <div className="valuation-container">
        <div className="valuation-cards">
          {cards.map((card, index) => (
            <div
              className="card-v"
              key={index}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
            >
              <div className="card-icon-v">{card.icon}</div>
              <h2 className={hoverIndex === index ? "subtitle-card" : "title-card"}>
                {hoverIndex === index ? <> {card.subtitle} </> : card.title}
              </h2>
              {(hoverIndex === index) && (
                <button className="know-more-button">Know More</button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuationApproach;
